"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeAddonAsRuleFactory = makeAddonAsRuleFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
function makeAddonAsRuleFactory(convertAndFormat) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return x;
    };
  }
  return function ruleProductFactory(appliedAddOns) {
    if (Array.isArray(appliedAddOns) && appliedAddOns.length > 0) {
      return appliedAddOns.map(function (addOn) {
        var _addOn$options, _addOn$additionalData, _addOn$additionalData2;
        var totalPrice = convertAndFormat((0, _get2.default)(addOn, 'displayPrice.totalWithVat', 0));
        return {
          code: addOn === null || addOn === void 0 ? void 0 : (_addOn$options = addOn.options) === null || _addOn$options === void 0 ? void 0 : _addOn$options.miscellaneous,
          description: addOn === null || addOn === void 0 ? void 0 : (_addOn$additionalData = addOn.additionalData) === null || _addOn$additionalData === void 0 ? void 0 : (_addOn$additionalData2 = _addOn$additionalData._pricingRules) === null || _addOn$additionalData2 === void 0 ? void 0 : _addOn$additionalData2.name,
          totalPrice: totalPrice,
          displayedTotalPrice: "" + totalPrice,
          displayedCurrency: addOn === null || addOn === void 0 ? void 0 : addOn.displayCurrency,
          isServiceFee: false,
          isDiscount: false
        };
      });
    }
    return [];
  };
}